module.exports = __webpack_public_path__ + "media/entering-room-knock.4e157726.mp3";